import { useLanguage } from '../hooks/useLanguage';

export default function LanguageSwitcher() {
  const { currentLanguage, toggleLanguage } = useLanguage();

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 hover:bg-white/20 transition-all duration-300 border border-white/20 backdrop-blur-sm"
      aria-label="Toggle language"
    >
      <span className={`text-sm font-medium transition-colors ${currentLanguage === 'fr' ? 'text-white' : 'text-white/50'}`}>
        FR
      </span>
      <div className="relative w-10 h-5 bg-white/20 rounded-full">
        <div
          className={`absolute top-0.5 w-4 h-4 bg-gradient-to-r from-[#FF6B6B] to-[#4ECDC4] rounded-full transition-all duration-300 ${
            currentLanguage === 'en' ? 'left-5' : 'left-0.5'
          }`}
        />
      </div>
      <span className={`text-sm font-medium transition-colors ${currentLanguage === 'en' ? 'text-white' : 'text-white/50'}`}>
        EN
      </span>
    </button>
  );
}